// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formLabel {
  font-size: 13px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: block;
  margin-bottom: 0.5rem;
}

.customBtn {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  padding: 0.25rem 0;
}

.custom__seg-back {
  background-color: #f5fcfd;
}
`, "",{"version":3,"sources":["webpack://./src/pages/definition/taskStyles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".formLabel {\n  font-size: 13px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.customBtn {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n  padding: 0.25rem 0;\n}\n\n.custom__seg-back {\n  background-color: #f5fcfd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
